import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export default class CountdownTimer {
  constructor(startDate, daysLimit, options = {}) {
    this.startDate = new Date(startDate);
    this.daysLimit = daysLimit;
    this.timeLimit = daysLimit * 86400;
    this.formatOptions = options.formatOptions || {};
    this.onUpdate = options.onUpdate || (() => {});
    this.onExpire = options.onExpire || (() => {});
    this.intervalId = null;
  }

  getTimeRemaining() {
    const timeElapsed = Math.floor((Date.now() - this.startDate) / 1000);

    if (timeElapsed >= this.timeLimit) {
      return null;
    }

    const timeRemaining = this.timeLimit - timeElapsed;
    const dur = dayjs.duration(timeRemaining, 'seconds');

    return {
      days: Math.floor(dur.asDays()),
      hours: dur.hours(),
      minutes: dur.minutes(),
      seconds: dur.seconds(),
    };
  }

  isExpired() {
    return this.getTimeRemaining() === null;
  }

  format() {
    const remaining = this.getTimeRemaining();

    if (!remaining) {
      return null;
    }

    return `${remaining.days}J ${remaining.hours}h ${remaining.minutes}m ${remaining.seconds}s`;
  }

  start() {
    if (this.isExpired()) {
      this.onExpire();
      return;
    }

    this.onUpdate(this.format());
    this.intervalId = setInterval(() => {
      if (this.isExpired()) {
        this.stop();
        this.onExpire();
      } else {
        this.onUpdate(this.format());
      }
    }, 1000);
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
